<template>
  <main class="main-wrap">
    <div class="min-s-hight" style="width:100%">
      <section class="r-s-wrap">
        <div class="container devExtremeGridContainer">
          <div class="row ">
            <div class="col-12 col-sm-12 col-md-3 col-lg-4">
              <div class="form-group has-search " style="width:100%;">
                <span class="fa fa-search form-control-feedback"></span>
                <input
                  v-model="inquiryReportSearched"
                  type="text"
                  class="form-control"
                  placeholder="Search by customer name"
                  @keyup.enter="inquiryAnalysis(0)"
                />
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-9 col-lg-8 ">
              <div class="pull-right displayflex mrtop">
                <!-- <input
                v-model="dateFrom"
                class="dateControl btnmaxwidth"
                type="date"
              />
              <input
                v-model="dateTo"
                class="mr-l20 dateControl btnmaxwidth"
                type="date"
                :min="dateFrom"
              /> -->
                <datepicker
                  v-if="onoffFirstDatePicker"
                  v-model="dateFrom"
                  :disabled-dates="disabledDatesFrom"
                  :monday-first="true"
                  :typeable="false"
                  class="my-datepicker mr-r20"
                  calendar-class="my-datepicker_calendar"
                  input-class="booking_input input-bl form-control "
                  format="MM/dd/yyyy"
                  placeholder="Select date"
                  :use-utc="true"
                  @selected="validationForSecondFilter"
                ></datepicker>

                <datepicker
                  v-if="onoff"
                  v-model="dateTo"
                  :disabled-dates="disabledDates"
                  :monday-first="true"
                  :typeable="false"
                  class="my-datepicker mr-r20"
                  calendar-class="my-datepicker_calendar"
                  input-class="booking_input input-bl form-control "
                  format="MM/dd/yyyy"
                  placeholder="Select date"
                  :use-utc="true"
                  @selected="validationForFirstFilter"
                ></datepicker>

                <!-- <button>Search</button> -->
                <button
                  type="button"
                  class="btn s-red-btn s-red-width bigSearch"
                  @click="inquiryAnalysis(0)"
                >
                  Search
                </button>
                <button
                  type="button"
                  class="btn s-red-btn s-red-width  smallSearch"
                  @click="inquiryAnalysis(0)"
                >
                  <span class="fa fa-search form-control-feedback "></span>
                </button>
              </div>
            </div>
          </div>
          <div class="mr-t20 row col-chooser">
            <div style="max-width:100%;">
              <DxDataGrid
                ref="inquiryAnalysisSection"
                :data-source="AllInquiryArray"
                :show-borders="true"
                :hover-state-enabled="true"
                :remote-operations="false"
                :allow-column-reordering="true"
                :row-alternation-enabled="false"
                :column-hiding-enabled="true"
                key-expr="Id"
                :show-column-lines="true"
                :show-row-lines="true"
              >
                <!-- <DxPaging :page-size="5" />
                      <DxPager
                        :show-page-size-selector="true"
                        :allowed-page-sizes="pageSizes"
                        :show-info="true"
                      /> -->

                <!-- <DxFilterRow :visible="true" /> -->
                <!-- <DxHeaderFilter :visible="true" /> -->
                <DxGroupPanel :visible="true" />
                <DxSearchPanel
                  :visible="false"
                  :highlight-case-sensitive="true"
                />
                <DxGrouping :auto-expand-all="true" />

                <DxPager
                  :allowed-page-sizes="[5, 10, 20]"
                  :show-page-size-selector="true"
                  :show-info="true"
                  :show-navigation-buttons="true"
                />
                <DxPaging :page-size="20" />
                <DxColumnChooser :enabled="true" />
                <DxColumn
                  data-field="CustomerName"
                  caption="Customer Name"
                  cell-template="CTemplate"
                  :allow-sorting="true"
                  :width="210"
                />
                <div slot="CTemplate" slot-scope="{ data }">
                  <h6> {{ data.CustomerName }} </h6>
                </div>

                <!-- <DxColumn
        data-field="Email"
        caption="Email"
        cell-template="EmailTemplate"
        :allow-sorting="true"
        alignment="left"
        :width="150"
      />
      <div slot="EmailTemplate" slot-scope="{ data }">
        <h6 class="break-big-word">
          {{ data.Email ? data.Email : 'Not Available' }}
        </h6>
      </div> -->
                <!-- <DxColumn
        data-field="Contact"
        caption="Contact"
        cell-template="ContactTemplate"
        :allow-sorting="true"
        :width="175"
      />
      <div slot="ContactTemplate" slot-scope="{ data }">
        <h6>
          {{ data.Phone ? data.Phone : 'Not Available' }}
        </h6>
      </div> -->

                <DxColumn
                  data-field="ServiceName"
                  caption="Service Name"
                  cell-template="STemplate"
                  :allow-sorting="true"
                  :width="190"
                />
                <div slot="STemplate" slot-scope="{ data }">
                  <h6> {{ data.ServiceName }} </h6>
                </div>
                <DxColumn
                  data-field="BuildingName"
                  caption="Building Name"
                  cell-template="BLTemplate"
                  :allow-sorting="true"
                  :width="180"
                />
                <div slot="BLTemplate" slot-scope="{ data }">
                  <h6> {{ data.BuildingName }} </h6>
                </div>
                <DxColumn
                  data-field="CreateDateUTC"
                  caption="Requested On"
                  cell-template="createdDateTemplate"
                  :calculate-cell-value="formatDateCreated"
                  :calculate-sort-value="calculateSortValue"
                  :allow-sorting="true"
                />
                <div slot="createdDateTemplate" slot-scope="{ data }">
                  <h6>{{ data.CreateDateUTC | formatDate }} </h6>
                </div>
                <DxColumn
                  data-field="Rating"
                  caption="Inquiry Rating"
                  cell-template="RatingTemplate"
                  :allow-sorting="true"
                  :width="140"
                  alignment="center"
                />
                <div slot="RatingTemplate" slot-scope="{ data }">
                  <!-- <h6> {{ data.Rating }} </h6> -->
                  <StarRating
                    :rating="data.Rating"
                    :increment="1"
                    active-color="#D13851"
                    :star-size="25"
                    :read-only="true"
                    :show-rating="false"
                    text-class="custom-text"
                  ></StarRating>
                </div>
                <DxColumn
                  data-field="Feedback"
                  caption="Feedback"
                  cell-template="FBTemplate"
                  :allow-sorting="false"
                  :width="220"
                />
                <div slot="FBTemplate" slot-scope="{ data }">
                  <!-- <h6> {{ data.Feedback }} </h6> -->
                  <textarea
                    v-if="data.Feedback"
                    id="message"
                    v-model="data.Feedback"
                    class="form-control"
                    name="message"
                    placeholder=""
                    rows="3"
                    readonly
                  >
                  </textarea>
                  <textarea
                    v-if="!data.Feedback"
                    id="message"
                    class="form-control"
                    name="message"
                    placeholder="Not Submitted"
                    rows="1"
                    readonly
                  >
                  </textarea>
                </div>
              </DxDataGrid>
            </div>
          </div>
        </div>
      </section>
      <loader v-if="isLoading"></loader>
    </div>
  </main>
</template>
<script>
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import { superAdminMethods } from '@state/helpers'
import StarRating from 'vue-star-rating'

import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  // DxStateStoring,
  // DxHeaderFilter,
  // DxFilterRow,
} from 'devextreme-vue/data-grid'

import loader from '@views/loader'
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxGrouping,
    DxGroupPanel,
    DxColumnChooser,
    loader,
    datepicker,
    StarRating,
  },
  filters: {
    formatDate: function(value) {
      if (!value) return ''
      return moment(String(value)).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'MMMM YYYY',
      })
    },
  },
  props: ['startDate', 'endDate'],
  data() {
    return {
      AllInquiryArray: [],
      dateFrom: '2018-01-01',
      dateTo: '2021-02-15',
      isLoading: false,
      inquiryReportSearched: '',
      disabledDates: {
        to: new Date(this.startDate),
      },
      disabledDatesFrom: {
        from: new Date(this.endDate),
      },
      onoff: true,
      onoffFirstDatePicker: true,
    }
  },
  watch: {
    inquiryReportSearched: {
      handler: function(val, oldVal) {
        if (!val) {
          this.AllInquiryArray = []
          this.inquiryAnalysis(0)
        }
      },
      deep: true,
    },
  },
  created() {
    this.dateFrom = this.startDate
    this.dateTo = this.endDate
    this.inquiryAnalysis(0)
  },
  methods: {
    ...superAdminMethods,
    // Toggling of the flag variable for the validation of date
    validationForSecondFilter(res) {
      this.disabledDates = {
        to: res,
      }
      this.onoff = false
      this.onoff = true
    },
    validationForFirstFilter(res) {
      this.disabledDatesFrom = {
        from: res,
      }
      this.onoffFirstDatePicker = false
      this.onoffFirstDatePicker = true
    },

    // Format Date
    formatDateCreated(data) {
      if (!data.CreateDateUTC) return ''
      return moment(String(data.CreateDateUTC)).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'MMMM YYYY',
      })
    },
    calculateSortValue(data) {
      if (!data.CreateDateUTC) return ''
      let valueDay = moment(String(data.CreateDateUTC)).format('YYYY-MM-DD')
      return valueDay
    },
    // GET API to fetch the inquiry count
    async inquiryAnalysis(recordCount) {
      try {
        this.isLoading = true
        // this.dateFrom = moment(String(this.dateFrom)).format('YYYY-MM-DD')
        let dateFromFilter = moment(String(this.dateFrom))
          .add(1, 'd')
          .format('YYYY-MM-DD')
        // this.dateTo = moment(String(this.dateTo)).format('YYYY-MM-DD')
        let dateTOFilter = moment(String(this.dateTo))
          .add(1, 'd')
          .format('YYYY-MM-DD')
        const inquiryReport = await this.InquiryAnalysisAsyncfunction({
          start: dateFromFilter,
          end: dateTOFilter,
          inquiryName: this.inquiryReportSearched
            ? this.inquiryReportSearched
            : '',
          recordAvailable: recordCount,
        })
        console.log('recordCount :', recordCount)
        console.log(inquiryReport)
        if (recordCount) {
          this.AllInquiryArray = this.AllInquiryArray.concat(inquiryReport)
        } else {
          this.AllInquiryArray = inquiryReport
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    // Adding the pagination in the dev extreme grid on  event trigger

    isLastPage(pagination) {
      var currentPage = pagination.value + 1
      var TotalPage = this.$refs['AllInquiriesArray'].instance.pageCount()
      var pageIndex = this.$refs['AllInquiriesArray'].instance.pageIndex() + 1
      if (
        pageIndex === currentPage &&
        currentPage === TotalPage &&
        this.AllInquiriesArray.length > 99
      ) {
        console.log('Pagination started working')
        this.inquiryAnalysis(this.AllInquiriesArray.length)
      } else if (pagination.fullName === 'paging.pageSize') {
        if (
          typeof pagination.previousValue === 'number' &&
          typeof pagination.value === 'number' &&
          pagination.value > pagination.previousValue &&
          this.AllInquiriesArray.length > 99
        ) {
          console.log('Pagination due to page size increment')
          this.inquiryAnalysis(this.AllInquiriesArray.length)
        }
      }
    },
  },
}
</script>

<style scoped></style>
